import { ProviderCardProps } from "@app/projects/network-assessment/maps/network-coverage-map/interfaces";
import { JSX } from "react"

export const ProviderCard = (
  {  children, containerClassName, highlightedStyles, provider, onClick }: ProviderCardProps
): JSX.Element => {

  const handleCardClick = () => {
    onClick(provider);
  }

  return (
    <div className={`network-coverage-map__provider-card ${containerClassName}`} style={highlightedStyles} onClick={handleCardClick}>
      <h6>{provider.displayName}</h6>
      <p>{provider.address}, {provider.city}, {provider.state} {provider.zip}</p>
      <p><strong>NPI:</strong> {provider.npi}</p>
      {children}
    </div>
  )
}